import { DISPLAYABLE_ESIM_STATUS_LIST } from "@features/ManageSim/constants";
import { IESim } from "@pages/AccountDetails/interface/IAccountDetailsPage";

export const isESimStatusActivated = (eSim: IESim) => DISPLAYABLE_ESIM_STATUS_LIST.includes(eSim.esimStatus);
